module.exports = __webpack_public_path__ + "static/gsch2-9deff8aa67e9ef7fe52368b371f0cf26.jpg";